import { createAsyncTypes } from 'utils/ActionCreator'

export const GET_AGENT_TOKEN_ASYNC = createAsyncTypes('GET_AGENT_TOKEN_ASYNC', 'Agents')

export const GENERATE_STATUS_TOKEN_ASYNC = createAsyncTypes('GENERATE_STATUS_TOKEN_ASYNC', 'Agents')

export const GET_AGENT_STATUS_BATCH_ASYNC = createAsyncTypes(
  'GET_AGENT_STATUS_BATCH_ASYNC',
  'Agents'
)

export const GET_BILLING_STATUS_ASYNC = createAsyncTypes('GET_BILLING_STATUS_ASYNC', 'Agents')

/**
 * Tenant billing type returned by the billing/status endpoint (`tenantType`).
 * Values are lower-case to match the backend enum.
 *   PLG          — free preview plan (not purchased)
 *   PAYG         — pay-as-you-go
 *   PREPURCHASE  — pre-purchased credit bundle
 *   POV          — proof-of-value (unlimited, no billing)
 */
export const TENANT_TYPE = {
  PLG: 'plg',
  PAYG: 'payg',
  PREPURCHASE: 'prepurchase',
  POV: 'pov',
}

export const GET_PHISHING_SOC_TRIAL_ASYNC = createAsyncTypes(
  'GET_PHISHING_SOC_TRIAL_ASYNC',
  'Agents'
)

export const ENABLE_PHISHING_SOC_TRIAL_ASYNC = createAsyncTypes(
  'ENABLE_PHISHING_SOC_TRIAL_ASYNC',
  'Agents'
)

export const DISABLE_PHISHING_SOC_TRIAL_ASYNC = createAsyncTypes(
  'DISABLE_PHISHING_SOC_TRIAL_ASYNC',
  'Agents'
)

export const REQUEST_THEMIS_SUMMARY_ASYNC = createAsyncTypes(
  'REQUEST_THEMIS_SUMMARY_ASYNC',
  'Agents'
)

export const GET_ATO_CAMPAIGN_BANNER_ASYNC = createAsyncTypes(
  'GET_ATO_CAMPAIGN_BANNER_ASYNC',
  'Agents'
)

export const POST_ATO_CAMPAIGN_CONTACT_ME_ASYNC = createAsyncTypes(
  'POST_ATO_CAMPAIGN_CONTACT_ME_ASYNC',
  'Agents'
)

export const DELETE_ATO_CAMPAIGN_BANNER_ASYNC = createAsyncTypes(
  'DELETE_ATO_CAMPAIGN_BANNER_ASYNC',
  'Agents'
)

// MERGE_COMPANY_CREDITS / UPDATE_CREDITS_REMAINING are gone with the
// company-credits endpoint — both were already dispatch-less. A live balance
// push should update billingStatus instead.
